import "./form-first-layout.css";

// Ordine reale del documento: promessa, campi, approfondimento. Nessun form duplicato.
export const FormFirstLayout = ({ intro, form, proof, testId }) => (
    <div className="container lead-grid form-first-grid" data-testid={testId}>
        <div className="form-first-intro" data-lead-intro data-testid={`${testId}-intro`}>{intro}</div>
        <div className="lead-side form-first-fields" data-testid={`${testId}-fields`}>{form}</div>
        <div className="form-first-proof" data-testid={`${testId}-proof`}>{proof}</div>
    </div>
);